import RadioButton from '../../general/RadioButton'
import Select from '../../general/Select'
import TextArea from '../../general/TextArea'
import { InfoDataType, ScreenType } from '../../../types/Types'

function GeschwindigkeitsVerstoss({ infoData, setInfoData, dark }: ScreenType) {
    const setCheckedValue = (name: string, value: string) => {
        setInfoData((prevInfoData: InfoDataType) => ({
            ...prevInfoData,
            screenGeschwindigkeitsverstoss: {
                ...prevInfoData.screenGeschwindigkeitsverstoss,
                [name]: value,
            },
        }))
    }

    const handleSelectChange = (selectedValue: string) => {
        setInfoData((prevInfoData: InfoDataType) => ({
            ...prevInfoData,
            screenGeschwindigkeitsverstoss: {
                ...prevInfoData.screenGeschwindigkeitsverstoss,
                geschwindigkeitsueberschreitung: selectedValue,
            },
        }))
    }

    const handleTextAreaChange = (
        e: React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const { value } = e.target
        setInfoData((prevInfoData: InfoDataType) => ({
            ...prevInfoData,
            screenGeschwindigkeitsverstoss: {
                ...prevInfoData.screenGeschwindigkeitsverstoss,
                note: value,
            },
        }))
    }

    const selectOptions = [
        { label: '0 - 15 km/h', value: '0 bis 15' },
        { label: '16 - 20 km/h', value: '16 bis 20' },
        { label: '21 - 30 km/h', value: '21 bis 30' },
        { label: '31 - 40 km/h', value: '31 bis 40' },
        { label: 'mehr als 40 km/h', value: 'mehr als 40' },
    ]
    return (
        <div className="pr-2">
            <h5 className="w-full pt-2 text-xl pb-2 font-semibold text-secondary">
                Angaben zum Vorwurf
            </h5>

            <div className="flex flex-col md:grid grid-cols-5 gap-6 ">
                <div className="col-span-3">
                    <p>Ort der Geschwindigkeitsüberschreitung*</p>
                </div>
                <div className="grid grid-cols-2 col-span-2 gap-2">
                    <RadioButton
                        label="Innerorts"
                        name="ort"
                        value="Innerorts"
                        checkedValue={
                            infoData.screenGeschwindigkeitsverstoss.ort || ''
                        }
                        setCheckedValue={setCheckedValue}
                        dark={dark}
                    />
                    <RadioButton
                        label="Außerorts"
                        name="ort"
                        value="Außerorts"
                        checkedValue={
                            infoData.screenGeschwindigkeitsverstoss.ort || ''
                        }
                        setCheckedValue={setCheckedValue}
                        dark={dark}
                    />
                </div>

                <div className="col-span-3">
                    <p>Fahrzeugtyp*</p>
                </div>
                <div className="grid grid-cols-2 col-span-2 gap-2">
                    <RadioButton
                        label="PKW/Motorrad"
                        name="fahrzeugtyp"
                        value="PKW/Motorrad"
                        checkedValue={
                            infoData.screenGeschwindigkeitsverstoss
                                .fahrzeugtyp || ''
                        }
                        setCheckedValue={setCheckedValue}
                        dark={dark}
                    />
                    <RadioButton
                        label="LKW"
                        name="fahrzeugtyp"
                        value="LKW"
                        checkedValue={
                            infoData.screenGeschwindigkeitsverstoss
                                .fahrzeugtyp || ''
                        }
                        setCheckedValue={setCheckedValue}
                        dark={dark}
                    />
                </div>

                <div className="col-span-3">
                    <p>Geschwindigkeitsüberschreitung*</p>
                </div>
                <div className="grid grid-cols-2 col-span-2 gap-2">
                    <Select
                        placeholder="Bitte Auswählen ..."
                        options={selectOptions}
                        handleSelectChange={handleSelectChange}
                        selectedValue={
                            infoData.screenGeschwindigkeitsverstoss
                                .geschwindigkeitsueberschreitung || ''
                        }
                        dark={dark}
                    />
                </div>

                <div className="col-span-3">
                    <p>
                        Wurden Sie innerhalb der letzten 12 Monate <br />{' '}
                        bereits mit mehr als 26 km/h geblitzt?*
                    </p>
                </div>
                <div className="grid grid-cols-2 col-span-2 gap-2">
                    <RadioButton
                        label="Ja"
                        name="oft"
                        value="Ja"
                        checkedValue={
                            infoData.screenGeschwindigkeitsverstoss.oft || ''
                        }
                        setCheckedValue={setCheckedValue}
                        dark={dark}
                    />
                    <RadioButton
                        label="Nein"
                        name="oft"
                        value="Nein"
                        checkedValue={
                            infoData.screenGeschwindigkeitsverstoss.ort || ''
                        }
                        setCheckedValue={setCheckedValue}
                        dark={dark}
                    />
                </div>

                <div className="col-span-3">
                    <p>Sind Sie beruflich auf den Führerschein angewiesen?*</p>
                </div>
                <div className="grid grid-cols-2 col-span-2 gap-2">
                    <RadioButton
                        label="Ja"
                        name="fuehrerschein"
                        value="Ja"
                        checkedValue={
                            infoData.screenGeschwindigkeitsverstoss
                                .fuehrerschein || ''
                        }
                        setCheckedValue={setCheckedValue}
                        dark={dark}
                    />
                    <RadioButton
                        label="Nein"
                        name="fuehrerschein"
                        value="Nein"
                        checkedValue={
                            infoData.screenGeschwindigkeitsverstoss
                                .fuehrerschein || ''
                        }
                        setCheckedValue={setCheckedValue}
                        dark={dark}
                    />
                </div>
                <div className="col-span-3"></div>
                <div className="col-span-2">
                    <TextArea
                        placeholder="Liegen Besonderheiten vor ?"
                        handleTextAreaChange={handleTextAreaChange}
                        value={
                            infoData.screenGeschwindigkeitsverstoss.note || ''
                        }
                        dark={dark}
                    />
                </div>

                <div className="col-span-3">
                    <p>Welche Dokumente wurden Ihnen bereits zugestellt?</p>
                </div>
                <div className="flex flex-col gap-2">
                    <RadioButton
                        label="Zeugenfragebogen"
                        name="zeugenfragebogen"
                        value="Zeugenfragebogen"
                        checkedValue={
                            infoData.screenGeschwindigkeitsverstoss
                                .zeugenfragebogen || ''
                        }
                        setCheckedValue={setCheckedValue}
                        dark={dark}
                    />
                    <RadioButton
                        label="Anhörungsbogen"
                        name="anhoerungsbogen"
                        value="Anhörungsbogen"
                        checkedValue={
                            infoData.screenGeschwindigkeitsverstoss
                                .anhoerungsbogen || ''
                        }
                        setCheckedValue={setCheckedValue}
                        dark={dark}
                    />
                    <RadioButton
                        label="Bußgeldbescheid"
                        name="bussgeldbescheid"
                        value="Bussgeldbescheid"
                        checkedValue={
                            infoData.screenGeschwindigkeitsverstoss
                                .bussgeldbescheid || ''
                        }
                        setCheckedValue={setCheckedValue}
                        dark={dark}
                    />
                </div>
            </div>
        </div>
    )
}

export default GeschwindigkeitsVerstoss
